"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _internal = require("../../theme/internal");

var _style = require("../../style");

var genQRCodeStyle = function genQRCodeStyle(token) {
  var _Object$assign, _ref;

  var componentCls = token.componentCls;
  return _ref = {}, _defineProperty(_ref, componentCls, Object.assign(Object.assign({}, (0, _style.resetComponent)(token)), (_Object$assign = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: token.paddingSM,
    backgroundColor: token.colorWhite,
    borderRadius: token.borderRadiusLG,
    border: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorSplit),
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  }, _defineProperty(_Object$assign, "& > ".concat(componentCls, "-mask"), _defineProperty({
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    color: token.colorText,
    lineHeight: token.lineHeight,
    background: token.QRCodeMaskBackgroundColor,
    textAlign: 'center'
  }, "& > ".concat(componentCls, "-expired"), {
    color: token.QRCodeExpiredTextColor
  })), _defineProperty(_Object$assign, '&-icon', {
    marginBlockEnd: token.marginXS,
    fontSize: token.controlHeight
  }), _Object$assign))), _defineProperty(_ref, "".concat(componentCls, "-borderless"), {
    borderColor: 'transparent'
  }), _ref;
};

var _default = (0, _internal.genComponentStyleHook)('QRCode', function (token) {
  return genQRCodeStyle((0, _internal.mergeToken)(token, {
    QRCodeExpiredTextColor: 'rgba(0, 0, 0, 0.88)',
    QRCodeMaskBackgroundColor: 'rgba(255, 255, 255, 0.96)'
  }));
});

exports.default = _default;